import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Phone, Mail, MapPin } from "lucide-react";
import { toast } from "sonner";
import { CONTACT } from "@/data/site";
import { api } from "@/lib/api";

export const Footer = () => {
  const [email, setEmail] = useState("");
  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    try { await api.post("/newsletter", { email }); toast.success("You're subscribed! Welcome to the table."); setEmail(""); }
    catch { toast.error("Please enter a valid email."); }
  };
  return (
    <footer className="bg-background border-t border-white/10 pt-20 pb-10" data-testid="footer">
      <div className="container-lux grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-1">
          <img src="/logo-official.png" alt="K.O Chef" className="h-24 w-auto mb-4" />
          <p className="text-sm text-white/50 italic font-serif">{CONTACT.tagline}</p>
        </div>
        <div>
          <h4 className="overline mb-5">Explore</h4>
          <ul className="space-y-3 text-sm text-white/60">
            {[["About","/about"],["Catering Services","/services"],["Build Your Menu","/build-your-menu"],["Menu Packages","/packages"],["Gallery","/gallery"],["Testimonials","/testimonials"],["FAQ","/faq"]].map(([l,t])=>(
              <li key={t}><Link to={t} className="hover:text-gold transition-colors">{l}</Link></li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="overline mb-5">Contact</h4>
          <ul className="space-y-4 text-sm text-white/60">
            <li className="flex gap-3"><MapPin className="w-4 h-4 text-gold shrink-0 mt-0.5"/>{CONTACT.areas}</li>
            <li className="flex gap-3"><Phone className="w-4 h-4 text-gold shrink-0 mt-0.5"/><span>{CONTACT.phoneEnName} (EN): {CONTACT.phoneEn}<br/>{CONTACT.phoneEsName} (ES): {CONTACT.phoneEs}</span></li>
            <li className="flex gap-3"><Mail className="w-4 h-4 text-gold shrink-0 mt-0.5"/>{CONTACT.email}</li>
          </ul>
          <div className="flex gap-4 mt-6">
            <a href={CONTACT.instagram} target="_blank" rel="noreferrer" className="w-10 h-10 border border-white/15 flex items-center justify-center text-white/70 hover:border-gold hover:text-gold transition-colors" data-testid="footer-instagram"><Instagram className="w-4 h-4"/></a>
            <a href={CONTACT.facebook} target="_blank" rel="noreferrer" className="w-10 h-10 border border-white/15 flex items-center justify-center text-white/70 hover:border-gold hover:text-gold transition-colors" data-testid="footer-facebook"><Facebook className="w-4 h-4"/></a>
          </div>
        </div>
        <div>
          <h4 className="overline mb-5">Newsletter</h4>
          <p className="text-sm text-white/50 mb-4">Seasonal menus & exclusive offers, straight to your inbox.</p>
          <form onSubmit={subscribe} className="space-y-4">
            <input data-testid="newsletter-email" type="email" value={email} onChange={(e)=>setEmail(e.target.value)} placeholder="Your email" className="lux-input" />
            <button className="btn-outline w-full !py-3" data-testid="newsletter-submit">Subscribe</button>
          </form>
        </div>
      </div>
      <div className="container-lux mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between gap-4 text-xs text-white/30 tracking-wide">
        <p>© {new Date().getFullYear()} {CONTACT.name}. All rights reserved.</p>
        <Link to="/admin" className="hover:text-gold transition-colors" data-testid="footer-admin-link">Owner Login</Link>
      </div>
    </footer>
  );
};

export default Footer;
